import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { CouponCompanyUsedModel, CouponItemModel, CouponListModel, CouponListQueryModel, GroupCouponModel } from '../../../model/builk/coupon/project-coupon.model';
import { CouponService } from '../../../service/api/builk/coupon.service';
import { AccessibilityComponent } from './modals/accessibility/accessibility.component';
import { CreateNewCouponComponent } from './modals/create-new-coupon/create-new-coupon.component';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';
import { CreateFreeCouponComponent } from './modals/create-free-coupon/create-free-coupon.component';
import { PageChangedEvent } from 'ngx-bootstrap';
import { CompanyUsedModalComponent } from './modals/company-used/company-used.component';

@Component({
  selector: 'app-coupon-setting',
  templateUrl: './coupon-setting.component.html',
  styleUrls: ['./coupon-setting.component.scss']
})
export class CouponSettingComponent implements OnInit {
  @ViewChild("createCouponModal") createCouponModal: CreateNewCouponComponent;
  @ViewChild("accessibilityModal") accessibilityModal: AccessibilityComponent;
  @ViewChild("confirm") confirmModal: ConfirmModalComponent;
  @ViewChild("createFreeCouponModal") createFreeCouponModal: CreateFreeCouponComponent;
  @ViewChild("companyUsedModal") companyUsedModal: CompanyUsedModalComponent;

  // list
  couponList: Array<GroupCouponModel> = new Array<GroupCouponModel>();
  couponResponse: CouponListModel = new CouponListModel();
  couponType: Array<{ value: any, label: string }> = [
    { value: 1, label: "Discount" },
    { value: 2, label: "Free" }
  ];

  // boolean
  isLoading: boolean = false;
  isError: boolean = false;

  //model
  deleteModel: CouponItemModel;
  query: CouponListQueryModel = new CouponListQueryModel();

  // number
  couponTypeValue: number;

  constructor(
    private couponService: CouponService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.initFilter();
    this.getCoupon();
  }

  initFilter() {
    this.query.couponType = this.couponTypeValue;
    this.query.pageNumber = 1;
    this.query.pageSize = 20;
    this.query.sortByDesc = true;
    this.query.sortColumn = '';
    this.query.textSearch = '';
  }

  getCoupon() {
    this.isLoading = true;
    this.couponService.getCoupon(this.query).subscribe(res => {
      this.couponResponse = res;
      this.couponList = res.itemList.map(val => {
        val.isShow = true;

        return val;
      });
      this.isLoading = false;
      this.isError = false;
    }, err => {
      console.log('Is Error')
      this.isError = true;
      this.isLoading = false;
      console.log(err.message);
    }, () => {
      this.isLoading = false;
    });
  }

  onFilterChange() {
    this.query.couponType = this.couponTypeValue;
    this.getCoupon();
  }

  toggleCoupon(model: CouponItemModel) {
    this.couponService.updateCoupon([model]).subscribe(res => {
      //console.log(res)
    });
  }

  openDelete(model: CouponItemModel) {
    this.deleteModel = model;
    this.confirmModal.show();
  }

  confirmDelete() {
    this.deleteModel.isDelete = true;
    this.couponService.updateCoupon([this.deleteModel]).subscribe(res => {
      //console.log(res)
      this.getCoupon();
    });
  }

  openCreateCouponModal () {
    this.createCouponModal.openModal();
  }

  openCreateFreeCouponModal () {
    this.createFreeCouponModal.openModal();
  }

  openAccessibilityModal () {
    this.accessibilityModal.openModal();
  }

  openEditCouponModal(value: CouponItemModel) {
    this.createCouponModal.edit(value);
  }

  openEditFreeCouponModal(value: CouponItemModel) {
    this.createFreeCouponModal.edit(value);
  }

  isSaved(val: boolean) {
    if (val) {
      this.getCoupon();
    }
  }

  newProduct(val: boolean) {
    this.openAccessibilityModal();
  }

  onPageChange(event: PageChangedEvent) {
    this.query.pageNumber = event.page;
    this.getCoupon();
  }

  onOpenCompanyUsed(value: Array<CouponCompanyUsedModel>) {
    this.companyUsedModal.openModal(value)
  }
}
